import { Dialog } from '@mui/material'
import { Box } from '@pets-ui/Box/Box'
import { Button } from '@pets-ui/Button/Button'
import { DialogHeader } from '@pets-ui/DialogHeader/DialogHeader'
import { Text } from '@pets-ui/Text/Text'
import { useStmBrandStore } from '../hooks'

interface DialogAuthChangedProps {
  onConfirm: () => void
}

export const DialogAuthChanged = ({ onConfirm }: DialogAuthChangedProps) => {
  const hasAnyExpiredBrand = useStmBrandStore(state => state.expiredCampaignCodes.length > 0)

  return (
    <Dialog disablePortal open={hasAnyExpiredBrand} PaperProps={{ sx: { borderRadius: '8px', width: 320 } }}>
      <DialogHeader title="帳號權限異動" />
      <Box px={4} pb={1}>
        <Text align="center">您的帳號存取權限已更新或移除</Text>
        <Text align="center">請重新登入才能套用新設定</Text>
      </Box>
      <Box p={4}>
        <Button color="red" fullWidth onClick={onConfirm}>
          重新登入
        </Button>
      </Box>
    </Dialog>
  )
}
